<template>
  <div>
    <form id="formConsulta" @submit.prevent="onSubmit()">
      <section class="filter d-flex justify-content-center">
        <div class="form-outline mt-3">
          <select v-if="dadosFiltrados.length > 0" v-model="opcaoSelecionada" class="form-select" @change="limpaLista">
            <option value="" selected>Selecione uma operadora</option>
            <option v-for="item in dadosFiltrados" :key="item.cdOpeda" :value="item.cdOpeda">{{ formatarDescricao(item) }}
            </option>
          </select>
          <label class="pt-2 ps-3" v-else>Carregando opções...</label>
        </div>
        <button type="submit" class="btn btn-primary btn-pesquisar" title="Pesquisar">
          <i class="fa-solid fa-search"></i>
        </button>
        <div>
        </div>
      </section>
    </form>
    <section class="lista-operadora" v-if="lista.length > 0">
      <div class="container">
        <h1>LISTA DE INTEGRAÇÕES</h1>
        <hr class="divider">
        <div class="row d-flex justify-content-center">

          <!-- auto -->
          <div v-if="automovel.length > 0" class="col-12 col-md-3 col-lg-2 d-flex justify-content-center">
            <div class="card">
              <div class="card-header">
                <img src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/ic_auto.svg" alt="" title=""
                  style="top: 8px; position: relative">
                <h1>AUTOMÓVEL</h1>
              </div>
              <div class="card-body">
                <ul>
                  <li>CORRETORES INTEGRADOS</li>
                  <li>{{ automovel[0].qtd_corretor }}</li>
                </ul>
              </div>
            </div>
          </div>

          <!-- residencial -->
          <div v-if="residencial.length > 0" class="col-12 col-md-3 col-lg-2 d-flex justify-content-center">
            <div class="card">
              <div class="card-header">
                <img src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/ic_residencial.svg" alt=""
                  title="">
                <h1>RESIDENCIAL</h1>
              </div>
              <div class="card-body">
                <ul>
                  <li>CORRETORES INTEGRADOS</li>
                  <li>{{ residencial[0].qtd_corretor }}</li>
                </ul>
              </div>
            </div>
          </div>

          <!-- imobiliário -->
          <div v-if="imobiliario.length > 0" class="col-12 col-md-3 col-lg-2 d-flex justify-content-center">
            <div class="card">
              <div class="card-header">
                <img src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/ic_imobiliario.svg" alt=""
                  title="">
                <h1>IMOBILIÁRIO</h1>
              </div>
              <div class="card-body">
                <ul>
                  <li>CORRETORES INTEGRADOS</li>
                  <li>{{ imobiliario[0].qtd_corretor }}</li>
                </ul>
              </div>
            </div>
          </div>

          <!-- condominio -->
          <div v-if="condominio.length > 0" class="col-12 col-md-3 col-lg-2 d-flex justify-content-center">
            <div class="card">
              <div class="card-header">
                <img src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/ic_condominio.svg" alt=""
                  title="" style=" width: 67px; top: 8px; position: relative;">
                <h1>CONDOMÍNIO</h1>
              </div>
              <div class="card-body">
                <ul>
                  <li>CORRETORES INTEGRADOS</li>
                  <li>{{ condominio[0].qtd_corretor }}</li>
                </ul>
              </div>
            </div>
          </div>

          <!-- vida -->
          <div v-if="vida.length > 0" class="col-12 col-md-3 col-lg-2 d-flex justify-content-center">
            <div class="card">
              <div class="card-header">
                <img src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/ic_vida.svg" alt="" title="">
                <h1>VIDA</h1>
              </div>
              <div class="card-body">
                <ul>
                  <li>CORRETORES INTEGRADOS</li>
                  <li>{{ vida[0].qtd_corretor }}</li>
                </ul>
              </div>
            </div>
          </div>

          <!-- aluguel -->
          <div v-if="aluguel.length > 0" class="col-12 col-md-3 col-lg-2 d-flex justify-content-center">
            <div class="card">
              <div class="card-header">
                <img src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/ic_aluguel.svg" alt="" title="">
                <h1>ALUGUEL</h1>
              </div>
              <div class="card-body">
                <ul>
                  <li>CORRETORES INTEGRADOS</li>
                  <li>{{ aluguel[0].qtd_corretor }}</li>
                </ul>
              </div>
            </div>
          </div>

          <!-- garantia -->
          <div v-if="garantia.length > 0" class="col-12 col-md-3 col-lg-2 d-flex justify-content-center">
            <div class="card">
              <div class="card-header">
                <img src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/ic_garantia.svg" alt="" title=""
                  style=" width: 50px">
                <h1>GARANTIA</h1>
              </div>
              <div class="card-body">
                <ul>
                  <li>CORRETORES INTEGRADOS</li>
                  <li>{{ garantia[0].qtd_corretor }}</li>
                </ul>
              </div>
            </div>
          </div>

          <!-- empresarial -->
          <div v-if="empresarial.length > 0" class="col-12 col-md-3 col-lg-2 d-flex justify-content-center">
            <div class="card">
              <div class="card-header">
                <img src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/ic_empresarial.svg" alt=""
                  title="">
                <h1>EMPRESARIAL</h1>
              </div>
              <div class="card-body">
                <ul>
                  <li>CORRETORES INTEGRADOS</li>
                  <li>{{ empresarial[0].qtd_corretor }}</li>
                </ul>
              </div>
            </div>
          </div>

          <!-- agro -->
          <div v-if="agro.length > 0" class="col-12 col-md-3 col-lg-2 d-flex justify-content-center">
            <div class="card">
              <div class="card-header">
                <img src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/ic_agro.svg" alt="" title="">
                <h1>AGRO SAFRAS</h1>
              </div>
              <div class="card-body">
                <ul>
                  <li>CORRETORES INTEGRADOS</li>
                  <li>{{ agro[0].qtd_corretor }}</li>
                </ul>
              </div>
            </div>
          </div>

          <!-- equipamentos -->
          <div v-if="equipamento.length > 0" class="col-12 col-md-3 col-lg-2 d-flex justify-content-center">
            <div class="card">
              <div class="card-header">
                <img src="/massificados/corporativo/gerenciador-parceiros-ui/consulta/img/ic_equipamentos.svg" alt=""
                  title="">
                <h1>EQUIPAMENTOS</h1>
              </div>
              <div class="card-body">
                <ul>
                  <li>CORRETORES INTEGRADOS</li>
                  <li>{{ equipamento[0].qtd_corretor }}</li>
                </ul>
              </div>
            </div>
          </div>
          <!-- viagem -->
        </div>

      </div>
    </section>

    <!-- <ul v-for="(item, index) in lista" :key="index">
      <li v-for="(value, key) in item" :key="key">{{ key }}: {{ value }}</li>
    </ul> -->

    <!-- <ul v-if="garantia.length > 0">
      <li v-for="(value, key) in garantia[0]" :key="key">{{ key }}: {{ value }}</li>
    </ul> -->

    <!-- <ul v-if="automovel.length > 0">
      <li>Produto: {{ automovel[0].codigoProduto }}</li>
      <li>Corretores Integrados: {{ automovel[0].qtd_corretor }}</li>
    </ul>
    <ul v-if="residencial.length > 0">
      <li>Produto: {{ residencial[0].codigoProduto }}</li>
      <li>Corretores Integrados: {{ residencial[0].qtd_corretor }}</li>
    </ul>
    <ul v-if="imobiliario.length > 0">
      <li>Produto: {{ imobiliario[0].codigoProduto }}</li>
      <li>Corretores Integrados: {{ imobiliario[0].qtd_corretor }}</li>
    </ul>
    <ul v-if="condominio.length > 0">
      <li>Produto: {{ condominio[0].codigoProduto }}</li>
      <li>Corretores Integrados: {{ condominio[0].qtd_corretor }}</li>
    </ul>
    <ul v-if="vida.length > 0">
      <li>Produto: {{ vida[0].codigoProduto }}</li>
      <li>Corretores Integrados: {{ vida[0].qtd_corretor }}</li>
    </ul>
    <ul v-if="aluguel.length > 0">
      <li>Produto: {{ aluguel[0].codigoProduto }}</li>
      <li>Corretores Integrados: {{ aluguel[0].qtd_corretor }}</li>
    </ul>
    <ul v-if="garantia.length > 0">
      <li>Produto: {{ garantia[0].codigoProduto }}</li>
      <li>Corretores Integrados: {{ garantia[0].qtd_corretor }}</li>
    </ul>
    <ul v-if="empresarial.length > 0">
      <li>Produto: {{ empresarial[0].codigoProduto }}</li>
      <li>Corretores Integrados: {{ empresarial[0].qtd_corretor }}</li>
    </ul>
    <ul v-if="agro.length > 0">
      <li>Produto: {{ agro[0].codigoProduto }}</li>
      <li>Corretores Integrados: {{ agro[0].qtd_corretor }}</li>
    </ul>
    <ul v-if="equipamento.length > 0">
      <li>Produto: {{ equipamento[0].codigoProduto }}</li>
      <li>Corretores Integrados: {{ equipamento[0].qtd_corretor }}</li>
    </ul> -->
  </div>
</template>

<script>
import * as alertUtils from '@/utils/alert';
import * as loaderUtils from '@/utils/loader';
export default {
  data() {
    return {
      operadoras: [],
      opcaoSelecionada: '',
      //operadorasFiltradas: [0,22],
      lista: [],
      token: '',
    };
  },
  mounted() {
    this.obterToken();
    this.obterOperadoras();
    document.querySelector("body").classList.remove("consulta-corretor");
    document.querySelector("body").classList.remove("consulta-operadora");
    document.querySelector("body").classList.add("consulta");

  },
  computed: {
    dadosFiltrados() {
      return this.operadoras
        //.filter(item => !this.operadorasFiltradas.includes(item.cdOpeda))
        .filter(item => item.tpOpeda !== 'B')
        .sort((a, b) => a.dsOpeda.localeCompare(b.dsOpeda, 'pt', { sensitivity: 'base' }));
    },

    automovel() {
      return this.lista.filter(item => item.codigoProduto === 7);
    },

    residencial() {
      return this.lista.filter(item => item.codigoProduto === 14);
    },

    imobiliario() {
      return this.lista.filter(item => item.codigoProduto === 43);
    },

    condominio() {
      return this.lista.filter(item => item.codigoProduto === 12);
    },

    vida() {
      return this.lista.filter(item => item.codigoProduto === 47);
    },

    aluguel() {
      return this.lista.filter(item => item.codigoProduto === 72);
    },

    garantia() {
      return this.lista.filter(item => item.codigoProduto === 7602 || item.codigoProduto === 7603);
    },

    empresarial() {
      return this.lista.filter(item => item.codigoProduto === 62);
    },

    agro() {
      return this.lista.filter(item => item.codigoProduto === 103);
    },

    equipamento() {
      return this.lista.filter(item => item.codigoProduto === 10005);
    }

  },
  methods: {
    onSubmit() {
      if (this.opcaoSelecionada === "") {
        alertUtils.alertError("Selecione uma operadora para realizar a pesquisa!");
      } else {
        this.obterToken()
          .then(() => {
            this.fetchData(this.opcaoSelecionada);
          })
          .catch((error) => {
            loaderUtils.removeLoader();
            alertUtils.alertError("Erro na autenticação:", error);
          });
      }
    },

    async obterToken() {
      this.token = "token";
    },
    /*
    async obterToken() {
      const urlAutenticacao = 'https://apis.tokiomarine.com.br/invoke/pub.apigateway.oauth2/getAccessToken';
      const dadosAutenticacao = {
        client_id: '950cef86-22e2-43cd-8456-2fe31378e61d',
        client_secret: '6d7e6330-adc4-4e6a-b7d3-5a43bc97a877',
        grant_type: 'client_credentials',
      };

      const formData = new FormData();
      for (const key in dadosAutenticacao) {
        formData.append(key, dadosAutenticacao[key]);
      }

      const requestOptions = {
        method: 'GET',
      };

      const urlComParametros = `${urlAutenticacao}?${new URLSearchParams(formData).toString()}`;

      try {
        const response = await fetch(urlComParametros, requestOptions);
        if (!response.ok) {
          throw new Error('Erro na obtenção do token');
        }

        const data = await response.json();
        this.token = data.access_token;
      } catch (error) {
        console.error('Erro na obtenção do token:', error);
      }
    },
    */

    async obterOperadoras() {
      try {
        await this.obterToken(); 

        //const operadorasUrl = 'https://apis.tokiomarine.com.br/gateway/gerenciador-parceiros/v1/rest/corretor/operadoras/';
        const operadorasUrl = 'https://servicos.tokiomarine.com.br/massificados/corporativo/gerenciador-parceiros/rest/corretor/operadoras/';
        const requestOptions = {
          method: 'GET',
          //headers: {
          //  Authorization: `Bearer ${this.token}`,
          //},
        };

        const response = await fetch(operadorasUrl, requestOptions);
        if (!response.ok) {
          throw new Error('Erro ao obter operadoras');
        }

        const data = await response.json();
        this.popularSelect(data);
      } catch (error) {
        console.error('Erro ao obter operadoras:', error);
      }
    },

    async fetchData(cod) {
      loaderUtils.addLoarder();

      try {
        await this.obterToken();

        //const operadorasUrl = `https://apis.tokiomarine.com.br/gateway/gerenciador-parceiros/v1/rest/corretor/operadoras/${cod}`;
        const operadorasUrl = `https://servicos.tokiomarine.com.br/massificados/corporativo/gerenciador-parceiros/rest/corretor/operadoras/${cod}`;
        const requestOptions = {
          method: 'GET',
          //headers: {
          //  Authorization: `Bearer ${this.token}`,
          //},
        };

        const response = await fetch(operadorasUrl, requestOptions);

        if (response.ok) {
          const data = await response.json();
          this.lista = data;

          setTimeout(() => {
            const cards = document.querySelectorAll('.card');
            const quantidade = cards.length;

            if (quantidade == 1) {
              document.querySelector("body").classList.add("consulta");
              document.querySelector("body").classList.remove("consulta-operadora");
            } else {
              document.querySelector("body").classList.add("consulta-operadora");
              document.querySelector("body").classList.remove("consulta");
            }
          }, 100);
        } else if (data.length === 0) {
          alertUtils.alertError("Nenhuma integração encontrada!");
          this.lista = '';
          document.querySelector("body").classList.add("consulta");
          document.querySelector("body").classList.remove("consulta-corretor");
        } else {
          throw new Error('Erro na requisição');
        }
      } catch (error) {
        loaderUtils.removeLoader();
        console.error('Erro na requisição:', error);
        alertUtils.alertError('Erro na requisição:', error);
      } finally {
        loaderUtils.removeLoader();
      }
    },

    popularSelect(data) {
      this.operadoras = data;
    },

    formatarDescricao(item) {
      if (item.tpOpeda === 'R') {
        return item.dsOpeda + ' - (ROBÔ)';
      }
      // Caso contrário, retornar a descrição original
      return item.dsOpeda;
    },

    limpaLista() {
      this.lista = '';
      document.querySelector("body").classList.remove("consulta-operadora");
      document.querySelector("body").classList.add("consulta");

    }
  }
};
</script>